import react from "react";
import axios from '../../axios/axiosconf'
import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumen from "./ModalResumen";
import ModalResumenEvolucion from "./ModalResumenEvolucion";
import { formatFecha } from "../../../resources/Helper";
import SignatureCanvas from 'react-signature-canvas';
import html2pdf from "html2pdf-fix-jspdf";
import { Modal, Button } from "react-bootstrap";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { generarPdfConTextoNativo } from '../../../utils/pdfHelpers';

function ModalEvolucion(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loadingPaciente, setLoadingPaciente] = useState(true); // 🆕 Loading específico para datos del paciente
    const [errorPaciente, setErrorPaciente] = useState(null); // 🆕 Error al cargar paciente
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState({});

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));
    const [paciente, setPaciente] = useState(null); // 🆕 Estado para datos del paciente cargados desde backend

    const [procedimiento, setProcedimiento] = useState('');
    const [proximaCita, setProximaCita] = useState('');
    const [eventosAdversos, setEventosAdversos] = useState('');
    const [planManejoEventoAdverso, setPlanManejoEventoAdverso] = useState('');
    const [horaInicial, setHoraInicial] = useState('');
    const [plantillasEventosAdversos, setPlantillasEventosAdversos] = useState([]);
    const panelPlanManejo = useRef(0);


    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [profesionalTratante, setProfesionalTratante] = useState(''); // 🆕 Profesional tratante (usuario logueado)

    const [historialEvoluciones, setHistorialEvoluciones] = useState([]);


    const [tituloResumen, setTituloResumen] = useState();
    const [resumenEvolucionIndividual, setResumenEvolucionIndividual] = useState();
    const [profesionalEvolucionIndividual, setProfesionalEvolucionIndividual] = useState();
    const [registroMedicoEvolucionIndividual, setRegistroMedicoEvolucionIndividual] = useState();
    const [codigoHabilitacionEvolucionIndividual, setCodigoHabilitacionEvolucionIndividual] = useState();
    const [firmaEvolucionIndividual, setFirmaEvolucionIndividual] = useState();
    const logoImg = '/smile/dist/img/logo-2.png';

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    const [errorlist, setErrorlist] = useState({});

    let history = useHistory();
    let userdata = [];

    const canvasRef = useRef(0);

    const [firmaPaciente, setFirmaPaciente] = useState('');
    const [fechaHora, setFechaHora] = useState('');

    const [listaPlantillas, setListaPlantillas] = useState([]);
    const refPlantilla = useRef();

    const [parametrosEvolucion, setParametrosEvolucion] = useState([]);
    const [contenidoPersonalizado, setContenidoPersonalizado] = useState('');
    const [habilitarBotonGuardar, setHabilitarBotonGuardar] = useState(false);

    const [showTratamientos, setShowtratamientos] = useState(false);
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [evolucionSeleccionada, setEvolucionSeleccionada] = useState(null);
    const [modoVisualizacion, setModoVisualizacion] = useState(false);
    const [showModalRips, setShowModalRips] = useState(false); // 🆕 Modal de confirmación RIPS
    const [esFacturador, setEsFacturador] = useState(false); // 🆕 Estado para saber si el usuario es facturador

    // 🎯 ESTADOS PARA ACORDEONES REACT - Todos abiertos por defecto para aprovechar espacio
    const [acordeonFechaHora, setAcordeonFechaHora] = useState(true);
    const [acordeonProcedimiento, setAcordeonProcedimiento] = useState(true);
    const [acordeonPersonalizado, setAcordeonPersonalizado] = useState(true);
    const [acordeonProximaCita, setAcordeonProximaCita] = useState(true);
    const [acordeonEventos, setAcordeonEventos] = useState(true);
    const [acordeonPlanManejo, setAcordeonPlanManejo] = useState(true);
    const [acordeonFirmaPaciente, setAcordeonFirmaPaciente] = useState(true);

    useEffect(() => {

        // 🆕 Usar prop esFacturador del padre en lugar de leer de localStorage
        if (props.esFacturador !== undefined && props.esFacturador !== null) {
            setEsFacturador(props.esFacturador);
            console.log('Campo facturador recibido del padre:', props.esFacturador, '→ Es facturador:', props.esFacturador);
        } else {
            // Fallback: leer de localStorage si no viene la prop
            if (localStorage.getItem('userdata')) {
                userdata = JSON.parse(localStorage.getItem('userdata'));
                
                if (userdata.facturador !== undefined && userdata.facturador !== null) {
                    const facturadorNum = parseInt(userdata.facturador);
                    setEsFacturador(facturadorNum === 0);
                    console.log('Campo facturador detectado en localStorage:', userdata.facturador, '(tipo:', typeof userdata.facturador, ') → Convertido a:', facturadorNum, '→ Es facturador:', facturadorNum === 0);
                } else {
                    console.log('Campo facturador no definido, usando valor por defecto (NO es facturador)');
                    setEsFacturador(false);
                }
            }
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        axios.get('/get-client')
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('plantillas-eventos-adversos')
            .then(response => {
                if (response.status === 200) {
                    setPlantillasEventosAdversos(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando plantillas eventos adversos:', error);
                setPlantillasEventosAdversos([]);
            });

        axios.get('/perfil')
            .then(response => {
                if (response.status === 200) {

                    setNombreProfesional(response.data.name + ' ' + response.data.lastname);
                    setProfesionalTratante(response.data.name + ' ' + response.data.lastname); // 🆕 Profesional tratante
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma_blob);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/otras-plantillas')
            .then(response => {
                if (response.status === 200) {
                    setListaPlantillas(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando otras plantillas:', error);
                setListaPlantillas([]);
            });

        axios.get('/parametros-evolucion')
            .then(response => {
                if (response.status === 200) {
                    setParametrosEvolucion(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando parámetros evolución:', error);
                setParametrosEvolucion(null);
            });

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

        // 🆕 TAREA 4.1.1 - Cargar datos del paciente desde backend
        if (paciente_id) {
            setLoadingPaciente(true);
            setErrorPaciente(null);
            
            // Usar endpoint existente /paciente con query params
            const configPaciente = {
                headers: {
                    Authorization: 'Bearer ' + userdata.access_token
                },
                params: {
                    id: paciente_id
                }
            };
            
            console.log('🔍 Cargando datos del paciente con ID:', paciente_id);
            
            axios.get('/paciente', configPaciente)
                .then(response => {
                    if (response.status === 200) {
                        console.log('✅ Datos del paciente recibidos del backend:', response.data);
                        
                        // El endpoint /paciente devuelve un array con un objeto
                        const datosPaciente = Array.isArray(response.data) ? response.data[0] : response.data;
                        
                        console.log('📋 Datos del paciente procesados:', {
                            primerNombre: datosPaciente.primer_nombre,
                            segundoNombre: datosPaciente.segundo_nombre,
                            primerApellido: datosPaciente.primer_apellido,
                            segundoApellido: datosPaciente.segundo_apellido,
                            tipoDocumento: datosPaciente.tipo_documento,
                            numeroDocumento: datosPaciente.numero_documento
                        });
                        
                        // Normalizar nombres de campos (snake_case a camelCase)
                        const pacienteNormalizado = {
                            primerNombre: datosPaciente.primer_nombre,
                            segundoNombre: datosPaciente.segundo_nombre,
                            primerApellido: datosPaciente.primer_apellido,
                            segundoApellido: datosPaciente.segundo_apellido,
                            tipoDocumento: datosPaciente.tipo_documento,
                            numeroDocumento: datosPaciente.numero_documento,
                            ...datosPaciente
                        };
                        
                        setPaciente(pacienteNormalizado);
                        console.log('✅ Estado paciente actualizado:', pacienteNormalizado);
                    }
                    setLoadingPaciente(false);
                })
                .catch(error => {
                    console.error('❌ Error cargando datos del paciente:', error);
                    console.error('❌ Detalles del error:', error.response?.data);
                    setErrorPaciente('No se pudieron cargar los datos del paciente');
                    setLoadingPaciente(false);
                });
        } else {
            console.error('❌ No se proporcionó ID de paciente en la URL');
            setErrorPaciente('No se proporcionó ID de paciente en la URL');
            setLoadingPaciente(false);
        }

    }, []);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };


    useEffect(() => {
        cargaritems();
    }, [props.cargarHistorial]);

    // 🆕 TAREA 4.1.1 - Helper para obtener datos del paciente (con fallback a props)
    const obtenerDatosPaciente = () => {
        // Priorizar datos cargados desde backend, fallback a props para compatibilidad
        const datosPaciente = paciente || props.paciente;
        
        console.log('🔍 obtenerDatosPaciente - datosPaciente:', datosPaciente);
        
        if (!datosPaciente) {
            console.warn('⚠️ No hay datos del paciente disponibles');
            return {
                nombreCompleto: 'Paciente no identificado',
                documentoCompleto: 'Documento no disponible'
            };
        }

        // Soportar tanto camelCase como snake_case
        const primerNombre = datosPaciente.primerNombre || datosPaciente.primer_nombre || '';
        const segundoNombre = datosPaciente.segundoNombre || datosPaciente.segundo_nombre || '';
        const primerApellido = datosPaciente.primerApellido || datosPaciente.primer_apellido || '';
        const segundoApellido = datosPaciente.segundoApellido || datosPaciente.segundo_apellido || '';
        const tipoDocumento = datosPaciente.tipoDocumento || datosPaciente.tipo_documento || '';
        const numeroDocumento = datosPaciente.numeroDocumento || datosPaciente.numero_documento || '';

        const nombreCompleto = `${primerNombre} ${segundoNombre} ${primerApellido} ${segundoApellido}`.trim() || 'Paciente no identificado';
        
        // Construir documento completo solo si hay datos válidos
        let documentoCompleto = 'Documento no disponible';
        if (tipoDocumento && numeroDocumento) {
            documentoCompleto = `${tipoDocumento} - ${numeroDocumento}`;
        } else if (numeroDocumento) {
            documentoCompleto = numeroDocumento;
        }

        console.log('✅ obtenerDatosPaciente - resultado:', { nombreCompleto, documentoCompleto });

        return {
            nombreCompleto,
            documentoCompleto,
            ...datosPaciente
        };
    };


    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/evoluciones', config2)
            .then(response => {

                setHistorialEvoluciones(response.data);

                let consolidadoItems = "";

                response.data.map((evol) => {

                    // 🎨 USAR EL MISMO FORMATO QUE LA VISTA INDIVIDUAL - Tablas con bandas grises

                    let profesionalTratanteNombre = (evol.profesional_tratante_completo && evol.profesional_tratante_completo !== 'null')
                        ? evol.profesional_tratante_completo
                        : 'No registrado';

                    // ✅ 1. Tabla de información de cabecera (Fecha y Profesional)
                    let segmentoCabecera = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">FECHA</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${evol.fecha}</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${profesionalTratanteNombre}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // ✅ 2. Tablas de contenido
                    let segmentoContenido = '';

                    // ❌ Procedimiento / Evolución - ELIMINADO
                    // if (evol.procedimiento) { ... }

                    // ✅ Contenido personalizado (campos de evolución)
                    let segmentoContenidoPersonalizado = renderizarContenidoPersonalizado(evol.contenido_personalizado);
                    if (segmentoContenidoPersonalizado) {
                        segmentoContenido += `
                            <div style="margin-bottom: 12px;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                    <tbody>
                                        <tr>
                                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">INFORMACIÓN ADICIONAL</td>
                                        </tr>
                                        <tr>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word;">
                                                ${segmentoContenidoPersonalizado}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>`;
                    }

                    // ❌ Próxima cita - ELIMINADO
                    // if (evol.proxima_cita) { ... }

                    // ✅ Eventos adversos
                    if (evol.eventos_adversos) {
                        segmentoContenido += `
                            <div style="margin-bottom: 12px;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                    <tbody>
                                        <tr>
                                            <td style="background-color: #fff3cd; font-weight: bold; padding: 8px 12px; border: 1px solid #ffc107; color: #856404;">⚠️ EVENTO ADVERSO</td>
                                        </tr>
                                        <tr>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word;">
                                                ${evol.eventos_adversos}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>`;
                    }

                    // Plan de manejo
                    if (evol.plan_manejo_evento_adverso) {
                        segmentoContenido += `
                            <div style="margin-bottom: 12px;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                    <tbody>
                                        <tr>
                                            <td style="background-color: #d1ecf1; font-weight: bold; padding: 8px 12px; border: 1px solid #17a2b8; color: #0c5460;">📋 PLAN DE MANEJO</td>
                                        </tr>
                                        <tr>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word;">
                                                ${evol.plan_manejo_evento_adverso}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>`;
                    }

                    // ✅ 3. Tabla de firmas (solo si hay firmas)
                    let tablaFirmas = '';

                    // Solo mostrar firma del profesional si hay profesional tratante registrado
                    let tieneProfesionalRegistrado = (evol.profesional_tratante_completo &&
                        evol.profesional_tratante_completo !== 'null' &&
                        evol.profesional_tratante_completo !== 'No registrado');

                    let mostrarFirmaProfesional = tieneProfesionalRegistrado && evol.firma;

                    if (mostrarFirmaProfesional || evol.firma_paciente) {
                        tablaFirmas = `
                            <div style="margin-top: 16px;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                    <tbody>`;

                        // Firma del Profesional (solo si hay profesional registrado Y firma)
                        if (mostrarFirmaProfesional) {
                            tablaFirmas += `
                                        <tr>
                                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                        </tr>
                                        <tr>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                                <img src="${evol.firma}" style="max-width: 180px; max-height: 90px; display: block;" />
                                                <div style="margin-top: 6px; font-size: 12px; color: #6c757d;">
                                                    ${evol.profesional || ''}<br/>
                                                    <strong>RM:</strong> ${evol.registro_medico || 'N/A'}
                                                </div>
                                            </td>
                                        </tr>`;
                        }

                        // Firma del Paciente (solo si existe)
                        if (evol.firma_paciente) {
                            tablaFirmas += `
                                        <tr>
                                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FIRMA DEL PACIENTE</td>
                                        </tr>
                                        <tr>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                                <img src="${evol.firma_paciente}" style="max-width: 180px; max-height: 90px; display: block;" />
                                            </td>
                                        </tr>`;
                        }

                        tablaFirmas += `
                                    </tbody>
                                </table>
                            </div>`;
                    }

                    // Separador entre evoluciones
                    let separadorEvolucion = `<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;">`;

                    const evolucionParcial = segmentoCabecera + segmentoContenido + tablaFirmas + separadorEvolucion;

                    consolidadoItems += evolucionParcial;
                });

                setConsolidado(consolidadoItems);
            })
            .catch(error => {
                console.log('Error cargando evoluciones:', error);
                setHistorialEvoluciones([]);
                setConsolidado('');
            })
    }



    const procedimientoHandler = (event, editor) => {
        setProcedimiento(editor.getData());
    }
    const proximaCitaHandler = (event, editor) => {
        setProximaCita(editor.getData());
    }
    const eventosAdversosHandler = (event, editor) => {
        setEventosAdversos(editor.getData());
    }
    const planManejoEventoAdversoHandler = (event, editor) => {
        setPlanManejoEventoAdverso(editor.getData());
    }


    const renderizarContenidoPersonalizado = (contenidoPersonalizado) => {

        if (!contenidoPersonalizado) {
            return "";
        }

        let contenido;
        try {
            contenido = JSON.parse(contenidoPersonalizado);
        } catch (e) {
            return "";
        }

        let resultado = "";

        if (contenido && Array.isArray(contenido)) {
            contenido.forEach((campo) => {
                // 🔧 OCULTAR CAMPOS VACÍOS - Solo mostrar si tiene valor
                if (campo.tipo === 'checkbox') {
                    // Para checkboxes, mostrar solo si está marcado - CON SALTO DE LÍNEA
                    if (campo.check) {
                        resultado += `<strong>${campo.nombre}:</strong> Sí<br />`;
                    }
                } else {
                    // Para otros campos, mostrar solo si tiene valor y no está vacío
                    if (campo.valor && campo.valor.trim() !== '') {
                        resultado += `<br /><label><strong>${campo.nombre}:</strong></label><br />${campo.valor}<br />`;
                    }
                }
            });
        }

        return resultado;
    }

    // 🔧 FUNCIÓN HELPER - Verificar si un campo tiene contenido válido
    const tieneContenido = (valor) => {
        if (!valor) return false;
        if (typeof valor === 'string') {
            // Remover HTML tags para verificar contenido real
            const textoLimpio = valor.replace(/<[^>]*>/g, '').trim();
            return textoLimpio !== '';
        }
        return true;
    }

    // 🔧 FUNCIÓN HELPER - Verificar si hay contenido personalizado válido
    const tieneContenidoPersonalizado = (contenidoPersonalizado) => {
        if (!contenidoPersonalizado) return false;

        try {
            const contenido = JSON.parse(contenidoPersonalizado);
            if (!contenido || !Array.isArray(contenido)) return false;

            // Verificar si hay al menos un campo con contenido válido
            return contenido.some(campo => {
                if (campo.tipo === 'checkbox') {
                    return campo.check === true;
                } else {
                    return campo.valor && campo.valor.trim() !== '';
                }
            });
        } catch (e) {
            return false;
        }
    }





    const handleSubmit = (e) => {

        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config = {
            paciente_id: pacienteId,
            profesional: nombreProfesional,
            firma: firmaimg,
            procedimiento: procedimiento,
            proxima_cita: proximaCita,
            eventos_adversos: eventosAdversos,
            plan_manejo_evento_adverso: planManejoEventoAdverso,
            hora_inicial: fechaHora || horaInicial,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido_personalizado: contenidoPersonalizado,
            firma_paciente: ''
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config.validar_asignacion = true;
        }

        if (canvasRef.current && !canvasRef.current.isEmpty()) {
            config.firma_paciente = canvasRef.current.toDataURL('image/png');
        }

        ///////////////////

        var contenidoPersonalizado = [];

        parametrosEvolucion.forEach((parametro) => {
            let campoPersonalizado = document.querySelector('#parametro_' + parametro.id);
            if (campoPersonalizado) {
                let nombreParametro = campoPersonalizado.dataset.nombre;
                let tipoParametro = campoPersonalizado.dataset.tipo;
                let valorParametro = campoPersonalizado.value;
                let checkParametro = campoPersonalizado.checked;

                let datoPersonalizado = { nombre: nombreParametro, tipo: tipoParametro, valor: valorParametro, check: checkParametro };

                contenidoPersonalizado.push(datoPersonalizado);
            }
        });

        config.contenido_personalizado = JSON.stringify(contenidoPersonalizado);

        ///////////////////

        console.log('Enviando datos de evolución:', config);

        axios.post('/evolucion', config)
            .then(response => {
                console.log('Evolución guardada exitosamente:', response.data);
                setLoading(false);
                setHabilitarBotonGuardar(true);
                cargaritems();
                setErrorlist({}); // Limpiar errores en caso de éxito

                // 🆕 Mostrar modal de confirmación RIPS después de guardar
                setShowModalRips(true);
            })
            .catch(error => {
                setLoading(false);
                console.log('Error al guardar evolución:', error);
                console.log('Respuesta del servidor:', error.response?.data);

                // Manejo robusto de errores
                if (error.response) {
                    if (error.response.data && error.response.data.errors) {
                        console.log('Errores de validación:', error.response.data.errors);
                        setErrorlist(error.response.data.errors);
                    } else if (error.response.data && error.response.data.message) {
                        console.log('Mensaje de error:', error.response.data.message);
                        setErrorlist({ general: error.response.data.message });
                    } else {
                        setErrorlist({ general: `Error ${error.response.status}: ${error.response.statusText}` });
                    }
                } else if (error.request) {
                    setErrorlist({ general: 'Error de conexión. Verifique su conexión a internet.' });
                } else {
                    setErrorlist({ general: 'Error inesperado al guardar la evolución.' });
                }
            })
    }



    const verEvolucion = (evolucion) => {
        // 🆕 CAMBIO: Cargar datos en formulario en lugar de abrir modal
        setEvolucionSeleccionada(evolucion);
        setModoVisualizacion(true);
        
        // Preparar contenido para el modal de resumen (se usará cuando se haga click en "Ver Resumen")
        setTituloResumen('Evolución Médica - Vista Previa');

        // 🆕 TAREA 4.1.1 - Obtener información del paciente usando helper
        const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();

        // 🎨 USAR EL MISMO FORMATO QUE EL PDF - Estilo tabla con bandas grises

        // 1. BANNER (igual que PDF)
        let banner = `
            <div style="margin-bottom: 12px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                    EVOLUCIÓN MÉDICA
                </div>
            </div>`;

        // 2. Tabla de información (igual que PDF)
        let profesionalTratanteNombre = (evolucion.profesional_tratante_completo && evolucion.profesional_tratante_completo !== 'null' && evolucion.profesional_tratante_completo !== 'No registrado')
            ? evolucion.profesional_tratante_completo
            : 'No registrado';

        let tablaInfoPaciente = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">FECHA</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${evolucion.fecha}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${profesionalTratanteNombre}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 3. Tabla de contenido (igual que PDF)
        let tablaContenido = '';

        // ✅ Contenido personalizado (campos de evolución)
        let contenidoPersonalizadoHTML = renderizarContenidoPersonalizado(evolucion.contenido_personalizado);
        if (contenidoPersonalizadoHTML) {
            tablaContenido += `
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">INFORMACIÓN ADICIONAL</td>
                            </tr>
                            <tr>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word;">
                                    ${contenidoPersonalizadoHTML}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        // ✅ Eventos adversos
        if (evolucion.eventos_adversos) {
            tablaContenido += `
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #fff3cd; font-weight: bold; padding: 8px 12px; border: 1px solid #ffc107; color: #856404;">⚠️ EVENTO ADVERSO</td>
                            </tr>
                            <tr>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word;">
                                    ${evolucion.eventos_adversos}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        if (evolucion.plan_manejo_evento_adverso) {
            tablaContenido += `
                <div style="margin-bottom: 12px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #d1ecf1; font-weight: bold; padding: 8px 12px; border: 1px solid #17a2b8; color: #0c5460;">📋 PLAN DE MANEJO</td>
                            </tr>
                            <tr>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; word-wrap: break-word; word-break: break-word; overflow-wrap: break-word;">
                                    ${evolucion.plan_manejo_evento_adverso}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        // 4. Firmas lado a lado (igual que PDF) - SIN CUADROS, SOLO LÍNEAS DIVISORIAS
        let tablaProfesional = '';

        // Solo mostrar firma si hay profesional tratante registrado
        let tieneProfesionalRegistrado = (evolucion.profesional_tratante_completo &&
            evolucion.profesional_tratante_completo !== 'null' &&
            evolucion.profesional_tratante_completo !== 'No registrado');

        let mostrarFirmaProfesional = tieneProfesionalRegistrado && evolucion.firma;

        if (mostrarFirmaProfesional || evolucion.firma_paciente) {
            tablaProfesional = `
                <div style="margin-top: 20px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px;">
                        <tbody>
                            <tr>`;
            
            // Columna izquierda: Firma del Profesional
            if (mostrarFirmaProfesional) {
                tablaProfesional += `
                                <td style="width: 50%; padding: 8px 12px; vertical-align: top;">
                                    <div style="font-weight: bold; margin-bottom: 4px;">FIRMA DEL PROFESIONAL</div>
                                    <hr style="border: none; border-top: 1px solid #dee2e6; margin: 4px 0 8px 0;" />
                                    <img src="${evolucion.firma}" style="max-width: 180px; max-height: 90px; display: block; margin-bottom: 8px;" />
                                    <div style="font-size: 11px; color: #6c757d;">
                                        ${evolucion.profesional || ''}<br/>
                                        <strong>RM:</strong> ${evolucion.registro_medico || 'N/A'}
                                    </div>
                                </td>`;
            } else {
                // Columna vacía si no hay firma profesional
                tablaProfesional += `
                                <td style="width: 50%; padding: 8px 12px;"></td>`;
            }

            // Columna derecha: Firma del Paciente
            if (evolucion.firma_paciente) {
                tablaProfesional += `
                                <td style="width: 50%; padding: 8px 12px; vertical-align: top;">
                                    <div style="font-weight: bold; margin-bottom: 4px;">FIRMA DEL PACIENTE</div>
                                    <hr style="border: none; border-top: 1px solid #dee2e6; margin: 4px 0 8px 0;" />
                                    <img src="${evolucion.firma_paciente}" style="max-width: 180px; max-height: 90px; display: block;" />
                                </td>`;
            } else {
                // Columna vacía si no hay firma paciente
                tablaProfesional += `
                                <td style="width: 50%; padding: 8px 12px;"></td>`;
            }

            tablaProfesional += `
                            </tr>
                        </tbody>
                    </table>
                    <hr style="border: none; border-top: 1px solid #dee2e6; margin: 8px 0;" />
                </div>`;
        }

        // Unir todo el contenido con el mismo formato que el PDF
        const contenidoResumen = banner + tablaInfoPaciente + tablaContenido + tablaProfesional;

        setResumenEvolucionIndividual(contenidoResumen);

        // 🆕 NO abrir modal automáticamente, solo preparar el contenido
        // El modal se abrirá cuando el usuario haga click en "Ver Resumen"
    }

    const establecerFechaHoraActual = () => {
        const ahora = new Date();
        const fechaFormateada = ahora.toISOString().slice(0, 16);
        setFechaHora(fechaFormateada);
        setHoraInicial(fechaFormateada);
    }

    const nuevaEvolucion = () => {
        setEvolucionSeleccionada(null);
        setModoVisualizacion(false);
        setHabilitarBotonGuardar(false);
        setFechaHora('');
        setErrorlist({}); // Limpiar errores
        // Limpiar formulario
        setProcedimiento('');
        setProximaCita('');
        setEventosAdversos('');
        setPlanManejoEventoAdverso('');
        // Resetear acordeones - Todos abiertos para aprovechar espacio
        setAcordeonFechaHora(true);
        setAcordeonProcedimiento(true);
        setAcordeonPersonalizado(true);
        setAcordeonProximaCita(true);
        setAcordeonEventos(true);
        setAcordeonPlanManejo(true);
        setAcordeonFirmaPaciente(true);
        parametrosEvolucion.forEach((parametro) => {
            const elemento = document.querySelector('#parametro_' + parametro.id);
            if (elemento) {
                if (parametro.tipo_campo === 'checkbox') {
                    elemento.checked = false;
                } else {
                    elemento.value = '';
                }
            }
        });
        if (canvasRef.current) {
            canvasRef.current.clear();
        }
    }

    const cargarDatosEnFormulario = (evolucion) => {
        if (parametrosEvolucion.length > 0) {
            setTimeout(() => {
                setProcedimiento(evolucion.procedimiento || '');
                setProximaCita(evolucion.proxima_cita || '');
                setEventosAdversos(evolucion.eventos_adversos || '');
                setPlanManejoEventoAdverso(evolucion.plan_manejo_evento_adverso || '');

                if (evolucion.contenido_personalizado) {
                    const contenido = JSON.parse(evolucion.contenido_personalizado);
                    contenido.forEach((campo) => {
                        parametrosEvolucion.forEach((parametro) => {
                            if (parametro.nombre === campo.nombre) {
                                const elemento = document.querySelector('#parametro_' + parametro.id);
                                if (elemento) {
                                    if (campo.tipo === 'checkbox') {
                                        elemento.checked = campo.check;
                                    } else {
                                        elemento.value = campo.valor;
                                    }
                                }
                            }
                        });
                    });
                }
                if (evolucion.firma_paciente && canvasRef.current) {
                    canvasRef.current.fromDataURL(evolucion.firma_paciente);
                }
            }, 200);
        }
    }

    const imprimirEvolucion = async () => {
        if (!evolucionSeleccionada) {
            alert('No hay evolución seleccionada para imprimir');
            return;
        }

        console.log('Imprimiendo evolución:', evolucionSeleccionada);

        try {
            // Preparar configuración para generarPdfConTextoNativo
            const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
            
            const config = {
                filename: 'evolucion-' + (props.docPaciente || 'paciente') + '.pdf',
                paciente: {
                    nombreCompleto: nombreCompleto,
                    documentoCompleto: documentoCompleto
                },
                encabezadoPersonalizado: encabezadoPersonalizado ? {
                    izquierda: encabezadoPersonalizado.izquierda || '',
                    centro: encabezadoPersonalizado.centro || '',
                    derecha: encabezadoPersonalizado.derecha || ''
                } : null,
                secciones: [],
                firmas: []
            };

            // Banner de título
            config.secciones.push({
                titulo: 'EVOLUCIÓN MÉDICA',
                tipo: 'banner',
                contenido: 'EVOLUCIÓN MÉDICA'
            });

            // Tabla de fecha y profesional
            const profesionalTratanteNombre = (evolucionSeleccionada.profesional_tratante_completo && 
                evolucionSeleccionada.profesional_tratante_completo !== 'null' && 
                evolucionSeleccionada.profesional_tratante_completo !== 'No registrado')
                ? evolucionSeleccionada.profesional_tratante_completo
                : 'No registrado';

            config.secciones.push({
                tipo: 'tabla-datos',
                datos: {
                    filas: [
                        { etiqueta: 'FECHA', valor: evolucionSeleccionada.fecha },
                        { etiqueta: 'PROFESIONAL TRATANTE', valor: profesionalTratanteNombre }
                    ]
                }
            });

            // Procedimiento / Evolución
            if (evolucionSeleccionada.procedimiento) {
                config.secciones.push({
                    titulo: 'PROCEDIMIENTO / EVOLUCIÓN',
                    contenido: evolucionSeleccionada.procedimiento,
                    tipo: 'texto'
                });
            }

            // Contenido personalizado
            if (evolucionSeleccionada.contenido_personalizado) {
                const contenidoHTML = renderizarContenidoPersonalizado(evolucionSeleccionada.contenido_personalizado);
                if (contenidoHTML) {
                    config.secciones.push({
                        titulo: 'INFORMACIÓN ADICIONAL',
                        contenido: contenidoHTML,
                        tipo: 'texto'
                    });
                }
            }

            // Próxima cita
            if (evolucionSeleccionada.proxima_cita) {
                config.secciones.push({
                    tipo: 'tabla-datos',
                    datos: {
                        filas: [
                            { etiqueta: 'PRÓXIMA CITA', valor: evolucionSeleccionada.proxima_cita }
                        ]
                    }
                });
            }

            // Eventos adversos
            if (evolucionSeleccionada.eventos_adversos) {
                config.secciones.push({
                    titulo: '⚠️ EVENTO ADVERSO',
                    contenido: evolucionSeleccionada.eventos_adversos,
                    tipo: 'texto',
                    estilos: {
                        headStyles: {
                            fillColor: [255, 243, 205],
                            textColor: [133, 100, 4]
                        }
                    }
                });
            }

            // Plan de manejo
            if (evolucionSeleccionada.plan_manejo_evento_adverso) {
                config.secciones.push({
                    titulo: '📋 PLAN DE MANEJO',
                    contenido: evolucionSeleccionada.plan_manejo_evento_adverso,
                    tipo: 'texto',
                    estilos: {
                        headStyles: {
                            fillColor: [209, 236, 241],
                            textColor: [12, 84, 96]
                        }
                    }
                });
            }

            // Firmas lado a lado usando tipo 'firmas-grupo'
            const tieneProfesionalRegistrado = (evolucionSeleccionada.profesional_tratante_completo &&
                evolucionSeleccionada.profesional_tratante_completo !== 'null' &&
                evolucionSeleccionada.profesional_tratante_completo !== 'No registrado');

            const mostrarFirmaProfesional = tieneProfesionalRegistrado && evolucionSeleccionada.firma;

            // Crear array de firmas para mostrar lado a lado
            const firmasGrupo = [];

            if (mostrarFirmaProfesional) {
                firmasGrupo.push({
                    imagenBase64: evolucionSeleccionada.firma,
                    metadata: {
                        tipo: 'profesional',
                        nombre: evolucionSeleccionada.profesional || '',
                        registroMedico: evolucionSeleccionada.registro_medico || 'N/A',
                        codigoHabilitacion: evolucionSeleccionada.codigo_habilitacion || 'N/A'
                    }
                });
            }

            if (evolucionSeleccionada.firma_paciente) {
                firmasGrupo.push({
                    imagenBase64: evolucionSeleccionada.firma_paciente,
                    metadata: {
                        tipo: 'paciente'
                    }
                });
            }

            // Agregar firmas como grupo si hay alguna
            if (firmasGrupo.length > 0) {
                config.secciones.push({
                    tipo: 'firmas-grupo',
                    firmas: firmasGrupo
                });
            }

            // Generar PDF
            const pdf = await generarPdfConTextoNativo(config);

            // Abrir diálogo de impresión
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');

            if (printWindow) {
                printWindow.onload = function() {
                    setTimeout(() => printWindow.print(), 500);
                };
            } else {
                // Fallback: iframe oculto
                console.log('Popup bloqueado, usando método alternativo');
                const iframe = document.createElement('iframe');
                iframe.style.position = 'fixed';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.src = url;
                document.body.appendChild(iframe);

                iframe.onload = function() {
                    setTimeout(() => {
                        try {
                            iframe.contentWindow.print();
                        } catch (e) {
                            alert('No se pudo abrir el diálogo de impresión. Por favor, descarga el PDF.');
                        }
                    }, 500);
                };
            }
        } catch (error) {
            console.error('Error generando PDF:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        }
    }

    const descargarPdfEvolucion = async () => {
        if (!evolucionSeleccionada) return;

        try {
            // Reutilizar la misma lógica de preparación que imprimirEvolucion
            const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
            
            const config = {
                filename: 'evolucion-' + (props.docPaciente || 'paciente') + '.pdf',
                paciente: {
                    nombreCompleto: nombreCompleto,
                    documentoCompleto: documentoCompleto
                },
                encabezadoPersonalizado: encabezadoPersonalizado ? {
                    izquierda: encabezadoPersonalizado.izquierda || '',
                    centro: encabezadoPersonalizado.centro || '',
                    derecha: encabezadoPersonalizado.derecha || ''
                } : null,
                secciones: [],
                firmas: []
            };

            // Banner de título
            config.secciones.push({
                titulo: 'EVOLUCIÓN MÉDICA',
                tipo: 'banner',
                contenido: 'EVOLUCIÓN MÉDICA'
            });

            // Tabla de fecha y profesional
            const profesionalTratanteNombre = (evolucionSeleccionada.profesional_tratante_completo && 
                evolucionSeleccionada.profesional_tratante_completo !== 'null' && 
                evolucionSeleccionada.profesional_tratante_completo !== 'No registrado')
                ? evolucionSeleccionada.profesional_tratante_completo
                : 'No registrado';

            config.secciones.push({
                tipo: 'tabla-datos',
                datos: {
                    filas: [
                        { etiqueta: 'FECHA', valor: evolucionSeleccionada.fecha },
                        { etiqueta: 'PROFESIONAL TRATANTE', valor: profesionalTratanteNombre }
                    ]
                }
            });

            // Procedimiento / Evolución
            if (evolucionSeleccionada.procedimiento) {
                config.secciones.push({
                    titulo: 'PROCEDIMIENTO / EVOLUCIÓN',
                    contenido: evolucionSeleccionada.procedimiento,
                    tipo: 'texto'
                });
            }

            // Contenido personalizado
            if (evolucionSeleccionada.contenido_personalizado) {
                const contenidoHTML = renderizarContenidoPersonalizado(evolucionSeleccionada.contenido_personalizado);
                if (contenidoHTML) {
                    config.secciones.push({
                        titulo: 'INFORMACIÓN ADICIONAL',
                        contenido: contenidoHTML,
                        tipo: 'texto'
                    });
                }
            }

            // Próxima cita
            if (evolucionSeleccionada.proxima_cita) {
                config.secciones.push({
                    tipo: 'tabla-datos',
                    datos: {
                        filas: [
                            { etiqueta: 'PRÓXIMA CITA', valor: evolucionSeleccionada.proxima_cita }
                        ]
                    }
                });
            }

            // Eventos adversos
            if (evolucionSeleccionada.eventos_adversos) {
                config.secciones.push({
                    titulo: '⚠️ EVENTO ADVERSO',
                    contenido: evolucionSeleccionada.eventos_adversos,
                    tipo: 'texto'
                });
            }

            // Plan de manejo
            if (evolucionSeleccionada.plan_manejo_evento_adverso) {
                config.secciones.push({
                    titulo: '📋 PLAN DE MANEJO',
                    contenido: evolucionSeleccionada.plan_manejo_evento_adverso,
                    tipo: 'texto'
                });
            }

            // Firmas
            const tieneProfesionalRegistrado = (evolucionSeleccionada.profesional_tratante_completo &&
                evolucionSeleccionada.profesional_tratante_completo !== 'null' &&
                evolucionSeleccionada.profesional_tratante_completo !== 'No registrado');

            const mostrarFirmaProfesional = tieneProfesionalRegistrado && evolucionSeleccionada.firma;

            if (mostrarFirmaProfesional) {
                config.firmas.push({
                    tipo: 'profesional',
                    imagenBase64: evolucionSeleccionada.firma,
                    metadata: {
                        nombre: evolucionSeleccionada.profesional || '',
                        registroMedico: evolucionSeleccionada.registro_medico || 'N/A',
                        codigoHabilitacion: evolucionSeleccionada.codigo_habilitacion || 'N/A'
                    }
                });
            }

            if (evolucionSeleccionada.firma_paciente) {
                config.firmas.push({
                    tipo: 'paciente',
                    imagenBase64: evolucionSeleccionada.firma_paciente,
                    metadata: {}
                });
            }

            // Generar y descargar PDF
            const pdf = await generarPdfConTextoNativo(config);
            pdf.save(config.filename);

        } catch (error) {
            console.error('Error generando PDF:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        }
    }

    // ❌ FUNCIÓN OBSOLETA - Comentada porque usa campos eliminados (procedimiento, proxima_cita)
    // Se usa verEvolucion() en su lugar
    /*
    const verResumenEvolucion = (ttlResumen, evolucionIndividual) => {
        setTituloResumen(ttlResumen);

        const segmentoFirmaPaciente = evolucionIndividual.firma_paciente ? "<br /><label>Firma del paciente</label><br /><img src='" + evolucionIndividual.firma_paciente + "' width='160' />" : "";
        let segmentoContenidoPersonalizado = renderizarContenidoPersonalizado(evolucionIndividual.contenido_personalizado);

        const contenidoEvolucion = "<label>Fecha:</label><br />" +
            evolucionIndividual.fecha +
            "<br /><label>Procedimiento:</label><br />" +
            evolucionIndividual.procedimiento +
            segmentoContenidoPersonalizado +
            "<label>Próxima cita:</label>" +
            evolucionIndividual.proxima_cita +
            "<label>Evento adverso:</label><br />" +
            evolucionIndividual.eventos_adversos +
            "<br /><br /><label>Plan de manejo evento adverso:</label><br />" +
            evolucionIndividual.plan_manejo_evento_adverso +
            segmentoFirmaPaciente;
        setResumenEvolucionIndividual(contenidoEvolucion);
        setProfesionalEvolucionIndividual(evolucionIndividual.profesional);
        setRegistroMedicoEvolucionIndividual(evolucionIndividual.registro_medico);
        setCodigoHabilitacionEvolucionIndividual(evolucionIndividual.codigo_habilitacion);
        setFirmaEvolucionIndividual(evolucionIndividual.firma);

        setShowModalResumen(true);
    }
    */


    const handleEventoAdverso = (evento) => {
        setEventosAdversos(evento.target.options[evento.target.selectedIndex].text);
        setPlanManejoEventoAdverso(evento.target.value);
        setAcordeonPlanManejo(true);
    }


    const imprimirConsolidado = async () => {
        try {
            const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
            
            const config = {
                filename: 'evoluciones-consolidado-' + (props.docPaciente || 'paciente') + '.pdf',
                paciente: {
                    nombreCompleto: nombreCompleto,
                    documentoCompleto: documentoCompleto
                },
                encabezadoPersonalizado: encabezadoPersonalizado ? {
                    izquierda: encabezadoPersonalizado.izquierda || '',
                    centro: encabezadoPersonalizado.centro || '',
                    derecha: encabezadoPersonalizado.derecha || ''
                } : null,
                secciones: [],
                firmas: []
            };

            // Banner de título
            config.secciones.push({
                titulo: 'HISTORIAL COMPLETO DE EVOLUCIONES',
                tipo: 'banner',
                contenido: 'HISTORIAL COMPLETO DE EVOLUCIONES'
            });

            // Procesar cada evolución del historial
            historialEvoluciones.forEach((evol, index) => {
                // Separador entre evoluciones (excepto la primera)
                if (index > 0) {
                    config.secciones.push({
                        tipo: 'texto',
                        contenido: '<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;">'
                    });
                }

                // Datos de cabecera
                const profesionalTratanteNombre = (evol.profesional_tratante_completo && 
                    evol.profesional_tratante_completo !== 'null' && 
                    evol.profesional_tratante_completo !== 'No registrado')
                    ? evol.profesional_tratante_completo
                    : 'No registrado';

                config.secciones.push({
                    tipo: 'tabla-datos',
                    datos: {
                        filas: [
                            { etiqueta: 'FECHA', valor: evol.fecha },
                            { etiqueta: 'PROFESIONAL TRATANTE', valor: profesionalTratanteNombre }
                        ]
                    }
                });

                // Contenido personalizado
                if (evol.contenido_personalizado) {
                    const contenidoHTML = renderizarContenidoPersonalizado(evol.contenido_personalizado);
                    if (contenidoHTML) {
                        config.secciones.push({
                            titulo: 'INFORMACIÓN ADICIONAL',
                            contenido: contenidoHTML,
                            tipo: 'texto'
                        });
                    }
                }

                // Eventos adversos
                if (evol.eventos_adversos) {
                    config.secciones.push({
                        titulo: '⚠️ EVENTO ADVERSO',
                        contenido: evol.eventos_adversos,
                        tipo: 'texto'
                    });
                }

                // Plan de manejo
                if (evol.plan_manejo_evento_adverso) {
                    config.secciones.push({
                        titulo: '📋 PLAN DE MANEJO',
                        contenido: evol.plan_manejo_evento_adverso,
                        tipo: 'texto'
                    });
                }

                // Firmas de esta evolución - AGRUPAR PARA MOSTRAR LADO A LADO
                const firmasEvolucion = [];
                
                const tieneProfesionalRegistrado = (evol.profesional_tratante_completo &&
                    evol.profesional_tratante_completo !== 'null' &&
                    evol.profesional_tratante_completo !== 'No registrado');

                const mostrarFirmaProfesional = tieneProfesionalRegistrado && evol.firma;

                if (mostrarFirmaProfesional) {
                    firmasEvolucion.push({
                        imagenBase64: evol.firma,
                        metadata: {
                            tipo: 'profesional',
                            nombre: evol.profesional || '',
                            registroMedico: evol.registro_medico || 'N/A',
                            codigoHabilitacion: evol.codigo_habilitacion || 'N/A'
                        }
                    });
                }

                if (evol.firma_paciente) {
                    firmasEvolucion.push({
                        imagenBase64: evol.firma_paciente,
                        metadata: {
                            tipo: 'paciente'
                        }
                    });
                }
                
                // Agregar firmas como grupo si hay alguna
                if (firmasEvolucion.length > 0) {
                    config.secciones.push({
                        tipo: 'firmas-grupo',
                        firmas: firmasEvolucion
                    });
                }
            });

            // Generar PDF
            const pdf = await generarPdfConTextoNativo(config);

            // Abrir diálogo de impresión
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');

        } catch (error) {
            console.error('Error generando PDF consolidado:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        }
    }

    const descargarPdf = async () => {
        try {
            const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
            
            const config = {
                filename: 'evoluciones-consolidado-' + (props.docPaciente || 'paciente') + '.pdf',
                paciente: {
                    nombreCompleto: nombreCompleto,
                    documentoCompleto: documentoCompleto
                },
                encabezadoPersonalizado: encabezadoPersonalizado ? {
                    izquierda: encabezadoPersonalizado.izquierda || '',
                    centro: encabezadoPersonalizado.centro || '',
                    derecha: encabezadoPersonalizado.derecha || ''
                } : null,
                secciones: [],
                firmas: []
            };

            // Banner de título
            config.secciones.push({
                titulo: 'HISTORIAL DE EVOLUCIONES',
                tipo: 'banner',
                contenido: 'HISTORIAL DE EVOLUCIONES'
            });

            // Procesar cada evolución del historial
            historialEvoluciones.forEach((evol, index) => {
                // Separador entre evoluciones (excepto la primera)
                if (index > 0) {
                    config.secciones.push({
                        tipo: 'texto',
                        contenido: '<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;">'
                    });
                }

                // Datos de cabecera
                const profesionalTratanteNombre = (evol.profesional_tratante_completo && 
                    evol.profesional_tratante_completo !== 'null' && 
                    evol.profesional_tratante_completo !== 'No registrado')
                    ? evol.profesional_tratante_completo
                    : 'No registrado';

                config.secciones.push({
                    tipo: 'tabla-datos',
                    datos: {
                        filas: [
                            { etiqueta: 'FECHA', valor: evol.fecha },
                            { etiqueta: 'PROFESIONAL TRATANTE', valor: profesionalTratanteNombre }
                        ]
                    }
                });

                // Contenido personalizado
                if (evol.contenido_personalizado) {
                    const contenidoHTML = renderizarContenidoPersonalizado(evol.contenido_personalizado);
                    if (contenidoHTML) {
                        config.secciones.push({
                            titulo: 'INFORMACIÓN ADICIONAL',
                            contenido: contenidoHTML,
                            tipo: 'texto'
                        });
                    }
                }

                // Eventos adversos
                if (evol.eventos_adversos) {
                    config.secciones.push({
                        titulo: '⚠️ EVENTO ADVERSO',
                        contenido: evol.eventos_adversos,
                        tipo: 'texto'
                    });
                }

                // Plan de manejo
                if (evol.plan_manejo_evento_adverso) {
                    config.secciones.push({
                        titulo: '📋 PLAN DE MANEJO',
                        contenido: evol.plan_manejo_evento_adverso,
                        tipo: 'texto'
                    });
                }

                // Firmas de esta evolución - AGRUPAR PARA MOSTRAR LADO A LADO
                const firmasEvolucion = [];
                
                const tieneProfesionalRegistrado = (evol.profesional_tratante_completo &&
                    evol.profesional_tratante_completo !== 'null' &&
                    evol.profesional_tratante_completo !== 'No registrado');

                const mostrarFirmaProfesional = tieneProfesionalRegistrado && evol.firma;

                if (mostrarFirmaProfesional) {
                    firmasEvolucion.push({
                        imagenBase64: evol.firma,
                        metadata: {
                            tipo: 'profesional',
                            nombre: evol.profesional || '',
                            registroMedico: evol.registro_medico || 'N/A',
                            codigoHabilitacion: evol.codigo_habilitacion || 'N/A'
                        }
                    });
                }

                if (evol.firma_paciente) {
                    firmasEvolucion.push({
                        imagenBase64: evol.firma_paciente,
                        metadata: {
                            tipo: 'paciente'
                        }
                    });
                }
                
                // Agregar firmas como grupo si hay alguna
                if (firmasEvolucion.length > 0) {
                    config.secciones.push({
                        tipo: 'firmas-grupo',
                        firmas: firmasEvolucion
                    });
                }
            });

            // Generar y descargar PDF
            const pdf = await generarPdfConTextoNativo(config);
            pdf.save(config.filename);

        } catch (error) {
            console.error('Error generando PDF consolidado:', error);
            alert('Error al generar el PDF. Por favor, intenta nuevamente.');
        }
    }


    const agregarPlantillaTratamiento = () => {

        let plantillaSeleccionada = refPlantilla.current.value;
        let proc = procedimiento;
        proc += plantillaSeleccionada;
        setProcedimiento(proc);
        handleCerrarTratamientos();
    }


    const renderCampoPersonalizado = (campo) => {
        if (modoVisualizacion && evolucionSeleccionada) {
            const contenido = JSON.parse(evolucionSeleccionada.contenido_personalizado || '[]');
            const valor = contenido.find(c => c.nombre === campo.nombre);

            // 🔧 OCULTAR CAMPOS VACÍOS - Solo mostrar si tiene valor
            if (!valor) {
                return null; // No renderizar si no hay valor
            }

            if (campo.tipo_campo === 'checkbox') {
                // Para checkboxes, solo mostrar si está marcado
                if (!valor.check) {
                    return null;
                }
                return (
                    <div className="form-group" key={campo.id}>
                        <label><strong>{campo.nombre}</strong></label>
                        <div className="form-control-plaintext">Sí</div>
                    </div>
                );
            } else {
                // Para otros campos, solo mostrar si tiene valor y no está vacío
                if (!valor.valor || valor.valor.trim() === '') {
                    return null;
                }
                return (
                    <div className="form-group" key={campo.id}>
                        <label><strong>{campo.nombre}</strong></label>
                        <div className="form-control-plaintext">{valor.valor}</div>
                    </div>
                );
            }
        }

        if (campo.tipo_campo == 'checkbox') {
            return <div className="form-group" key={campo.id}>
                <label>{campo.nombre}</label>
                <input type="checkbox" className="form-control" id={'parametro_' + campo.id} data-nombre={campo.nombre} data-tipo={campo.tipo_campo} style={{ width: '30px' }} />
            </div>
        }
        else if (campo.tipo_campo == 'text') {
            return <div className="form-group" key={campo.id}>
                <label>{campo.nombre}</label>
                <input type="text" className="form-control" id={'parametro_' + campo.id} data-nombre={campo.nombre} data-tipo={campo.tipo_campo} />
            </div>
        }
        else if (campo.tipo_campo == 'textarea') {
            return <div className="form-group" key={campo.id}>
                <label>{campo.nombre}</label>
                <textarea className="form-control" id={'parametro_' + campo.id} data-nombre={campo.nombre} data-tipo={campo.tipo_campo} rows="5"></textarea>
            </div>
        }
        else {
            // Fallback para cualquier otro tipo
            return <div className="form-group" key={campo.id}>
                <label>{campo.nombre}</label>
                <input type="text" className="form-control" id={'parametro_' + campo.id} data-nombre={campo.nombre} data-tipo={campo.tipo_campo} />
            </div>
        }
    }


    const handleCerrarTratamientos = () => setShowtratamientos(false);

    // 🆕 Funciones para manejar el modal de RIPS
    const handleCerrarModalRips = () => {
        setShowModalRips(false);
        // Limpiar campos para permitir nueva evolución
        nuevaEvolucion();
        // Mostrar toast de confirmación solo si la función existe (cuando se usa como modal)
        if (props.guardarCambios && typeof props.guardarCambios === 'function') {
            props.guardarCambios('La evolución ha sido completada');
        }
    };

    const handleRegistrarRipsFev = () => {
        setShowModalRips(false);
        // Cerrar modal de evolución solo si la función existe
        if (props.cerrarModal && typeof props.cerrarModal === 'function') {
            props.cerrarModal();
        }
        // Mostrar toast de confirmación solo si la función existe
        if (props.guardarCambios && typeof props.guardarCambios === 'function') {
            props.guardarCambios('La evolución ha sido completada');
        }
        // Abrir modal de RIPS FEV si la función está disponible
        if (props.abrirRipsFev && typeof props.abrirRipsFev === 'function') {
            props.abrirRipsFev();
        } else {
            // Si no hay función para abrir modal, redirigir o mostrar mensaje
            console.log('Función abrirRipsFev no disponible');
        }
    };

    const handleRegistrarRipsSinFev = () => {
        setShowModalRips(false);
        // Cerrar modal de evolución solo si la función existe
        if (props.cerrarModal && typeof props.cerrarModal === 'function') {
            props.cerrarModal();
        }
        // Mostrar toast de confirmación solo si la función existe
        if (props.guardarCambios && typeof props.guardarCambios === 'function') {
            props.guardarCambios('La evolución ha sido completada');
        }
        // Abrir modal de RIPS sin FEV si la función está disponible
        if (props.abrirRipsSinFev && typeof props.abrirRipsSinFev === 'function') {
            props.abrirRipsSinFev();
        } else {
            // Si no hay función para abrir modal, redirigir o mostrar mensaje
            console.log('Función abrirRipsSinFev no disponible');
        }
    };

    // Render del componente
    if (loggedIn) {
        return (

            <>
                <Header />
                <Aside />
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">

                        {/* 🆕 TAREA 4.1.2 y 4.1.3 - Mostrar loading o error al cargar paciente */}
                        {loadingPaciente && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert alert-info" role="alert">
                                        <i className="fas fa-spinner fa-spin"></i> Cargando datos del paciente...
                                    </div>
                                </div>
                            </div>
                        )}

                        {errorPaciente && (
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert alert-danger" role="alert">
                                        <i className="fas fa-exclamation-triangle"></i> {errorPaciente}
                                        <br />
                                        <button 
                                            type="button" 
                                            className="btn btn-secondary btn-sm mt-2"
                                            onClick={() => history.goBack()}
                                        >
                                            <i className="fas fa-arrow-left"></i> Volver
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {!loadingPaciente && !errorPaciente && (
                        <div className="row">
                            <div className="col-md-9">

                                {/* 🆕 TÍTULO Y BOTONES DE ACCIÓN SUPERIORES */}
                                <div className="card" style={{ marginBottom: '20px', backgroundColor: '#f8f9fa', borderLeft: '4px solid #343a40' }}>
                                    <div className="card-body" style={{ padding: '15px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <h3 style={{ margin: 0, color: '#343a40' }}>
                                                    <i className="fas fa-notes-medical"></i> EVOLUCIÓN DEL PACIENTE
                                                </h3>
                                                {/* Botones de navegación rápida */}
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-dark"
                                                    onClick={() => history.push(`/atender-paciente?id=${paciente_id}`)}
                                                    title="Volver a Atención del Paciente"
                                                    style={{ padding: '4px 8px' }}
                                                >
                                                    <i className="fas fa-user-injured"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-info"
                                                    onClick={() => history.push(`/estado-cuenta-paciente?id=${paciente_id}`)}
                                                    title="Ver Cartera del Paciente"
                                                    style={{ padding: '4px 8px' }}
                                                >
                                                    <i className="fas fa-dollar-sign"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-secondary"
                                                    onClick={() => history.goBack()}
                                                    title="Volver"
                                                    style={{ padding: '4px 8px' }}
                                                >
                                                    <i className="fas fa-arrow-left"></i>
                                                </button>
                                            </div>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-success btn-sm"
                                                    onClick={(e) => { e.preventDefault(); nuevaEvolucion(); }}
                                                >
                                                    <i className="fas fa-plus"></i> Nueva Evolución
                                                </button>
                                                {evolucionSeleccionada && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-info btn-sm"
                                                        onClick={(e) => { e.preventDefault(); setShowModalResumen(true); }}
                                                    >
                                                        <i className="fas fa-eye"></i> Ver Resumen
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        
                                        {/* 🆕 TAREA 4.1.4 - Información del paciente debajo del título */}
                                        <div style={{ marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #dee2e6' }}>
                                            {(() => {
                                                const { nombreCompleto, documentoCompleto } = obtenerDatosPaciente();
                                                return (
                                                    <div style={{ display: 'flex', gap: '30px', fontSize: '14px' }}>
                                                        <div>
                                                            <strong><i className="fas fa-user"></i> Paciente:</strong> {nombreCompleto}
                                                        </div>
                                                        <div>
                                                            <strong><i className="fas fa-id-card"></i> Documento:</strong> {documentoCompleto}
                                                        </div>
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                </div>

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    {/* Mostrar errores generales */}
                                    {errorlist?.general && (
                                        <div className="alert alert-danger" role="alert">
                                            <i className="fas fa-exclamation-triangle"></i> {errorlist.general}
                                        </div>
                                    )}

                                    <div id="historiageneral">
                                        <div className="row">
                                            {/* 🆕 PROFESIONAL TRATANTE - Arriba de todo */}
                                            {!modoVisualizacion && (
                                                <div className="col-md-12">
                                                    <div className="card" style={{ marginBottom: '15px' }}>
                                                        <div className="card-body" style={{ padding: '15px' }}>
                                                            <div className="form-group" style={{ marginBottom: '0' }}>
                                                                <label><i className="fas fa-user-md"></i> Profesional Tratante</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={profesionalTratante}
                                                                    readOnly
                                                                    style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                                                />
                                                                <small className="text-muted">Usuario que realiza la evolución</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* 🆕 PROFESIONAL TRATANTE - Modo visualización */}
                                            {modoVisualizacion && evolucionSeleccionada && (
                                                <div className="col-md-12">
                                                    <div className="card" style={{ marginBottom: '15px', backgroundColor: '#d1ecf1' }}>
                                                        <div className="card-body" style={{ padding: '15px' }}>
                                                            <div className="form-group" style={{ marginBottom: '0' }}>
                                                                <label><i className="fas fa-user-md"></i> Profesional Tratante</label>
                                                                <div className="form-control-plaintext" style={{ fontWeight: 'bold', color: evolucionSeleccionada.profesional_tratante_completo && evolucionSeleccionada.profesional_tratante_completo !== 'null' ? '#17a2b8' : '#6c757d' }}>
                                                                    {(evolucionSeleccionada.profesional_tratante_completo && evolucionSeleccionada.profesional_tratante_completo !== 'null') ? evolucionSeleccionada.profesional_tratante_completo : 'No registrado'}
                                                                </div>
                                                                <small className="text-muted">Usuario que realizó la evolución</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {!modoVisualizacion && (
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-header" onClick={() => setAcordeonFechaHora(!acordeonFechaHora)} style={{ cursor: 'pointer' }}>
                                                            <h4 className="card-title w-100">
                                                                <span className="d-block w-100">
                                                                    Fecha y Hora
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div id="fecha-hora" className={acordeonFechaHora ? '' : 'collapse'} style={{ padding: '20px' }}>
                                                            <div className="form-group">
                                                                <label>Fecha y Hora</label>
                                                                <div className="input-group">
                                                                    <input type="datetime-local" className="form-control" value={fechaHora} onChange={(e) => {
                                                                        setFechaHora(e.target.value);
                                                                        setHoraInicial(e.target.value);
                                                                    }} />
                                                                    <div className="input-group-append">
                                                                        <button type="button" className="btn btn-primary btn-sm" onClick={establecerFechaHoraActual}>
                                                                            <i className="fas fa-clock"></i> Hoy
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {/* ❌ ACORDEÓN PROCEDIMIENTO - ELIMINADO POR SOLICITUD DEL USUARIO */}
                                            {/* {(!modoVisualizacion || tieneContenido(evolucionSeleccionada?.procedimiento)) && (
                                                <div className="col-md-12">
                                                    ... código comentado ...
                                                </div>
                                            )} */}

                                            {/* 🔧 ACORDEÓN EVOLUCIÓN - Solo mostrar si tiene contenido o no está en modo visualización */}
                                            {parametrosEvolucion && (!modoVisualizacion || tieneContenidoPersonalizado(evolucionSeleccionada?.contenido_personalizado)) && (
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-header" onClick={() => setAcordeonPersonalizado(!acordeonPersonalizado)} style={{ cursor: 'pointer' }}>
                                                            <h4 className="card-title w-100">
                                                                <span className="d-block w-100">
                                                                    Evolución
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div id="personalizado" className={acordeonPersonalizado ? '' : 'collapse'} style={{ padding: '20px' }}>
                                                            {
                                                                parametrosEvolucion.map((parametro) =>
                                                                    renderCampoPersonalizado(parametro)
                                                                ).filter(campo => campo !== null) // 🔧 Filtrar campos nulos (vacíos)
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )}


                                            {/* ❌ ACORDEÓN PRÓXIMA CITA - ELIMINADO POR SOLICITUD DEL USUARIO */}
                                            {/* {(!modoVisualizacion || tieneContenido(evolucionSeleccionada?.proxima_cita)) && (
                                                <div className="col-md-12">
                                                    ... código comentado ...
                                                </div>
                                            )} */}
                                            {/* 🔧 ACORDEÓN EVENTOS ADVERSOS - Solo mostrar si tiene contenido o no está en modo visualización */}
                                            {(!modoVisualizacion || tieneContenido(evolucionSeleccionada?.eventos_adversos)) && (
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-header" onClick={() => setAcordeonEventos(!acordeonEventos)} style={{ cursor: 'pointer' }}>
                                                            <h4 className="card-title w-100">
                                                                <span className="d-block w-100">
                                                                    Eventos Adversos
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div id="eventos" className={acordeonEventos ? '' : 'collapse'}>
                                                            <div className="form-group" style={{ padding: '20px 32px' }}>
                                                                {modoVisualizacion ? (
                                                                    tieneContenido(evolucionSeleccionada?.eventos_adversos) ? (
                                                                        <div className="form-control-plaintext">{evolucionSeleccionada.eventos_adversos}</div>
                                                                    ) : null
                                                                ) : (
                                                                    <select className="form-control" id="evento" name="evento" onChange={(e) => handleEventoAdverso(e)}>
                                                                        <option></option>
                                                                        {
                                                                            plantillasEventosAdversos.map((plantilla) =>
                                                                                <option key={plantilla.id} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {errorlist?.eventos_adversos && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.eventos_adversos}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {/* 🔧 ACORDEÓN PLAN DE MANEJO - Solo mostrar si tiene contenido o no está en modo visualización */}
                                            {(!modoVisualizacion || tieneContenido(evolucionSeleccionada?.plan_manejo_evento_adverso)) && (
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-header" onClick={() => setAcordeonPlanManejo(!acordeonPlanManejo)} style={{ cursor: 'pointer' }}>
                                                            <h4 className="card-title w-100">
                                                                <span className="d-block w-100">
                                                                    Plan de Manejo del Evento Adverso
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div id="plan-manejo" className={acordeonPlanManejo ? '' : 'collapse'} ref={panelPlanManejo}>
                                                            <div className="form-group plan-manejo-ckeditor">
                                                                {modoVisualizacion ? (
                                                                    tieneContenido(evolucionSeleccionada?.plan_manejo_evento_adverso) ? (
                                                                        <div className="form-control-plaintext" dangerouslySetInnerHTML={{ __html: evolucionSeleccionada.plan_manejo_evento_adverso }} />
                                                                    ) : null
                                                                ) : (
                                                                    <CKEditor editor={ClassicEditor} onChange={planManejoEventoAdversoHandler} data={planManejoEventoAdverso} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {errorlist?.plan_manejo_evento_adverso && (
                                                        <div className="invalid-feedback visible">
                                                            {errorlist.plan_manejo_evento_adverso}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {/* 🔧 ACORDEÓN FIRMA DEL PACIENTE - Solo mostrar si tiene firma o no está en modo visualización */}
                                            {(!modoVisualizacion || (evolucionSeleccionada && evolucionSeleccionada.firma_paciente)) && (
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-header" onClick={() => setAcordeonFirmaPaciente(!acordeonFirmaPaciente)} style={{ cursor: 'pointer' }}>
                                                            <h4 className="card-title w-100">
                                                                <span className="d-block w-100">
                                                                    Firma Del Paciente
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div id="firma-paciente" className={acordeonFirmaPaciente ? '' : 'collapse'}>
                                                            <div className="form-group" style={{ padding: '20px' }}>
                                                                {modoVisualizacion ? (
                                                                    evolucionSeleccionada && evolucionSeleccionada.firma_paciente ?
                                                                        <img src={evolucionSeleccionada.firma_paciente} style={{ border: '1px solid', maxWidth: '300px' }} alt="Firma del paciente" /> :
                                                                        <div>No Hay Firma Registrada</div>
                                                                ) : (
                                                                    <>
                                                                        <SignatureCanvas ref={canvasRef} penColor='#242424' canvasProps={{ width: 300, height: 130, className: 'sigCanvas', style: { border: '1px solid' } }} />
                                                                        <br />
                                                                        <button className="btn btn-primary btn-sm" onClick={(e) => { e.preventDefault(); canvasRef.current.clear(); }}><i className="fas fa-eraser"></i> Borrar</button>&nbsp;
                                                                    </>
                                                                )}
                                                            </div>
                                                            {errorlist?.firma_paciente && (
                                                                <div className="invalid-feedback visible">
                                                                    {errorlist.firma_paciente}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div id="profesional-atiende">
                                            <div className="card-body" style={{ padding: '0.7rem' }}>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Profesional que atiende</label>
                                                            <br></br>
                                                            {nombreProfesional}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Registro médico</label>
                                                            <br></br>
                                                            {registroMedico}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="clasificacion_riesgo">Código de habilitación</label>
                                                            <br></br>
                                                            {codigoHabilitacion}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label htmlFor="nombreProfesional">Firma</label>
                                                            <br></br>
                                                            <img src={firmaimg} className="firma-profesional-hc" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            {!modoVisualizacion && (
                                                <button type="submit" className="btn btn-primary" disabled={habilitarBotonGuardar}>
                                                    Guardar&nbsp;
                                                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                                </button>
                                            )}
                                            {(modoVisualizacion || !modoVisualizacion) && <>&nbsp;</>}
                                            <button type="button" className="btn btn-secondary" onClick={() => history.goBack()}>
                                                <i className="fas fa-arrow-left"></i> Volver
                                            </button>
                                        </div>
                                    </div>

                                </form>


                            </div>
                            <div className="col-md-3" style={{ borderLeft: '2px solid #dee2e6', paddingLeft: '20px' }}>
                                <div className="timeline-evolucion">
                                    <div style={{ 
                                        textAlign: 'center', 
                                        marginBottom: '20px', 
                                        padding: '10px',
                                        backgroundColor: '#f8f9fa',
                                        borderRadius: '5px',
                                        border: '1px solid #dee2e6'
                                    }}>
                                        <i className="fas fa-history" style={{ color: '#343a40', marginRight: '8px' }}></i>
                                        <b style={{ color: '#343a40', fontSize: '16px' }}>Historial de Evoluciones</b>
                                    </div>

                                    {
                                        historialEvoluciones.map((evol) =>

                                            <div className={`timeline-item-container ${evolucionSeleccionada && evolucionSeleccionada.id === evol.id ? 'timeline-item-selected' : ''}`} key={evol.id} onClick={() => verEvolucion(evol)} style={{ cursor: 'pointer' }}>
                                                <div className="timeline-punto-container"><div className={`timeline-punto ${evolucionSeleccionada && evolucionSeleccionada.id === evol.id ? 'timeline-punto-selected' : ''}`} style={evolucionSeleccionada && evolucionSeleccionada.id === evol.id ? { backgroundColor: '#17a2b8', borderColor: '#17a2b8', boxShadow: '0 0 0 3px rgba(23, 162, 184, 0.2)' } : {}}></div></div>
                                                <div className="timeline-meta" style={evolucionSeleccionada && evolucionSeleccionada.id === evol.id ? { 
                                                    backgroundColor: '#d1ecf1', 
                                                    borderColor: '#17a2b8',
                                                    borderWidth: '2px',
                                                    fontWeight: 'bold'
                                                } : {}}>
                                                    <i className="far fa-calendar-alt" style={{ marginRight: '8px', color: '#6c757d' }}></i>
                                                    {formatFecha(new Date(evol.fecha))}
                                                </div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button className="btn btn-primary btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>
                                    <i className="fas fa-file-medical-alt"></i> Resumen Completo
                                </button>

                            </div>
                        </div>
                        )}
                        {/* 🆕 TAREA 4.1.2 - Cierre del div condicional de loading/error */}

                        </div>
                    </section>
                </div>
                <Footer />

                <Modal show={showModalResumen} onHide={() => setShowModalResumen(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{tituloResumen}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div dangerouslySetInnerHTML={{ __html: resumenEvolucionIndividual }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={descargarPdfEvolucion}>
                            <i className="fas fa-file-pdf"></i> Descargar PDF
                        </Button>
                        <Button variant="primary" onClick={imprimirEvolucion}>
                            <i className="fas fa-print"></i> Imprimir
                        </Button>
                        <Button variant="secondary" onClick={() => setShowModalResumen(false)}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showModalConsolidado} onHide={() => setShowModalConsolidado(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Resumen de Atenciones</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Botones de acción arriba del contenido */}
                        <div style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
                            <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={(e) => { e.preventDefault(); descargarPdf(); }}
                            >
                                <i className="fas fa-file-pdf"></i> Descargar PDF
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={(e) => { e.preventDefault(); imprimirConsolidado(); }}
                            >
                                <i className="fas fa-print"></i> Imprimir
                            </button>
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: consolidado }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModalConsolidado(false)}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showTratamientos} onHide={handleCerrarTratamientos}>
                    <Modal.Header closeButton>
                        <Modal.Title>Agregar tratamiento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <label>Otras plantillas</label>
                        <select className="form-control" id="seleccionPlantilla" size={5} ref={refPlantilla}>
                            {
                                listaPlantillas.map((plantilla) =>
                                    <option key={plantilla.id} value={plantilla.contenido}>{plantilla.titulo}</option>
                                )
                            }
                        </select>
                        <br />
                        <button className="btn btn-primary btn-sm" onClick={agregarPlantillaTratamiento}>Agregar +</button>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleCerrarTratamientos}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* 🆕 Modal de Confirmación RIPS */}
                <Modal show={showModalRips} onHide={handleCerrarModalRips} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <i className="fas fa-check-circle text-success"></i> Evolución Guardada
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p style={{ fontSize: '16px', marginBottom: '20px' }}>
                            La evolución del paciente fue guardada correctamente. ¿Deseas registrar los RIPS asociados a esta atención?
                        </p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {esFacturador ? (
                                // Usuario ES facturador (facturador = 0) → Mostrar botón RIPS FEV
                                <button
                                    className="btn btn-success btn-lg btn-block"
                                    onClick={handleRegistrarRipsFev}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}
                                >
                                    <i className="fas fa-file-invoice"></i>
                                    <span>Sí, Registrar RIPS FEV</span>
                                </button>
                            ) : (
                                // Usuario NO es facturador (facturador = 1) → Mostrar botón RIPS Sin FEV
                                <button
                                    className="btn btn-primary btn-lg btn-block"
                                    onClick={handleRegistrarRipsSinFev}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}
                                >
                                    <i className="fas fa-file-alt"></i>
                                    <span>Sí, Registrar RIPS Sin FEV</span>
                                </button>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCerrarModalRips}>
                            <i className="fas fa-times"></i> No, Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

            </>
        );
    }

    return (
        <Loading />
    );
}
export default ModalEvolucion;